const GENERIC_FIELD_TYPES = new Map([
  ["generic_text", "text"],
  ["generic_number", "number"],
  ["generic_dollar", "dollar"],
  ["generic_date", "date"],
  ["generic_multiline", "multiline"],
  ["generic_email", "email"],
  ["generic_phone", "mobile"],
  ["generic_money", "money"],
  ["generic_todaydate", "todayDate"],
  ["generic_full_title", "full_title"],
  ["generic_full_subtitle", "full_subTitle"],
  ["generic_total", "total"],
]);

export const getGenericFieldTypeFromId = (fieldId) =>
  GENERIC_FIELD_TYPES.get(
    String(fieldId ?? "")
      .trim()
      .toLowerCase(),
  );

// Restore frontend-only metadata after loading saved fields.
export const withGenericFieldType = (field) => {
  // Generic tables have their own type metadata.
  if (field?.generic_table) return field;

  const fieldType = getGenericFieldTypeFromId(field?.field_id);

  if (!fieldType || field.field_type === fieldType) return field;

  return {
    ...field,
    field_type: fieldType,
  };
};

// Apply to the finished field payload, immediately before sending it.
export const omitGenericFieldTypeFromPayload = (fieldPayload) => {
  if (
    fieldPayload?.generic_table ||
    !getGenericFieldTypeFromId(fieldPayload?.field_id)
  ) {
    return fieldPayload;
  }

  const { field_type, ...payloadWithoutFieldType } = fieldPayload;
  return payloadWithoutFieldType;
};
